import { FORM_TABS, FORM_ELEMENT_TYPES } from "../FormsConstant";

/**
 * Utilities for detecting workflow variable usage across form structure.
 */

/**
 * Returns distinct workflow variable ids referenced in form data (all tab host sections, including grid cells).
 * Only ids that exist in `customWorkflowVariables` are included.
 *
 * @param {Object} formData - Form content keyed by host section (e.g. subsections, hiddenSubsections)
 * @param {Array<{ id: string|number }>|undefined|null} customWorkflowVariables - Known workflow variables
 * @returns {Array<string|number>}
 * @author Abhishek Dhillon
 */
export const collectUsedWorkflowVariableIds = (formData, customWorkflowVariables = []) => {
  const knownIds = new Set((customWorkflowVariables ?? []).map((v) => v.id));
  const used = new Set();

  const collectFromProperties = (properties) => {
    if (!properties?.isWorkflowVariable || properties.workflowVariableId == null) {
      return;
    }
    const vid = properties.workflowVariableId;
    if (knownIds.has(vid)) {
      used.add(vid);
    }
  };

  const visitElement = (el) => {
    if (!el) {
      return;
    }
    collectFromProperties(el.properties);
    if (el.type === FORM_ELEMENT_TYPES.ROW_CONTAINER && el.gridElements) {
      el.gridElements.forEach((row) => {
        row?.forEach((cell) => visitElement(cell));
      });
    }
  };

  Object.values(FORM_TABS).forEach((tab) => {
    formData?.[tab?.hostSection]?.forEach((sub) => {
      sub?.elements?.forEach(visitElement);
    });
  });

  return [...used];
};
